import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.5 1.5H1.5V6.5H3.5V3.5H6.5V1.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 1.5H17.5V3.5H20.5V6.5H22.5V1.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.0549 7.34129L11.9997 3.8453L5.94548 7.34069L11.9991 10.8345L18.0549 7.34129Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.0614 9.06958L12.999 12.5666V19.5778L19.0619 16.0774L19.0614 9.06958Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.999 19.5769V12.5665L4.93841 9.06867L4.9375 16.0774L10.999 19.5769Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.5 20.5V17.5H1.5V22.5H6.5V20.5H3.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 22.5V17.5H20.5V20.5H17.5V22.5H22.5Z"}}]};

const ViewInArFilled = Vue.extend<IconProps>({
  name: 'ViewInArFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'view-in-ar-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ViewInArFilled;
